export default __webpack_public_path__ + "static/media/fever.6db04194.svg";